(ns kyber.styles.rich-text)

(defn rich-text-styles
  [gs]
  {".rich-text-container"
   {:font-family (gs [:font-family :open-sans])

    "& b"
    {:font-weight (gs [:font-weight :title-20])}

    "& i"
    {:font-style :italic}

    "& p"
    {:line-height (gs [:font-height :body-20])
     :font-size (gs [:font-size :body-20])
     :font-weight (gs [:font-weight :body-20])
     :color (gs [:colors :gray-scale-500])
     :margin-bottom "0.5em"

     (gs [:queries :tablet])
     {:font-size (gs [:font-size :body-20/tablet])}

     (gs [:queries :mobile-landscape])
     {:font-size (gs [:font-size :body-20/mobile])}}

    ;; Note Only 3 headers are used in the rich text editor
    ;; (h1->h4, h2->h5, h3->h6)
    "& h1,h4"
    {:line-height (gs [:font-height :title-30])
     :font-size (gs [:font-size :title-30])
     :font-weight (gs [:font-weight :title-30])
     :color (gs [:colors :gray-scale-600])
     :margin-bottom (gs [:font-height :title-30])

     (gs [:queries :tablet])
     {:font-size (gs [:font-size :title-30/tablet])}

     (gs [:queries :mobile-landscape])
     {:font-size (gs [:font-size :title-30/mobile])}}

    "& h2,h5"
    {:line-height (gs [:font-height :title-20])
     :font-size (gs [:font-size :title-20])
     :font-weight (gs [:font-weight :title-20])
     :color (gs [:colors :gray-scale-600])
     :margin-bottom (gs [:font-height :title-20])

     (gs [:queries :tablet])
     {:font-size (gs [:font-size :title-20/tablet])}

     (gs [:queries :mobile-landscape])
     {:font-size (gs [:font-size :title-20/mobile])}}

    "& h3,h6"
    {:line-height (gs [:font-height :title-10])
     :font-size (gs [:font-size :title-10])
     :font-weight (gs [:font-weight :title-10])
     :color (gs [:colors :gray-scale-600])
     :margin-bottom (gs [:font-height :title-10])

     (gs [:queries :tablet])
     {:font-size (gs [:font-size :title-10/tablet])}

     (gs [:queries :mobile-landscape])
     {:font-size (gs [:font-size :title-10/mobile])}}

    "& ul, ol"
    {"& li"
     {:line-height (gs [:font-height :body-20])
      :font-size (gs [:font-size :body-20])
      :font-weight (gs [:font-weight :body-20])
      :color (gs [:colors :gray-scale-500])
      :margin-bottom "1em"

      (gs [:queries :tablet])
      {:font-size (gs [:font-size :body-20/tablet])}

      (gs [:queries :mobile-landscape])
      {:font-size (gs [:font-size :body-20/mobile])}}}

    "& ul"
    {:list-style-type :disc
     :margin-left (gs [:spacing :p20])}

    "& ol"
    {:list-style-type :decimal
     :margin-left (gs [:spacing :p20])}}})
